module.exports = __webpack_public_path__ + "02bacf57e17b85d6af4a0d132cbc13fe.svg";


//////////////////
// WEBPACK FOOTER
// ./spa/images/icons/hamburger.svg
// module id = 1222
// module chunks = 65